import { render, staticRenderFns } from "./GameRuleSearchBarComponent.vue?vue&type=template&id=e0b4a2c4&scoped=true"
import script from "./GameRuleSearchBarComponent.vue?vue&type=script&lang=js"
export * from "./GameRuleSearchBarComponent.vue?vue&type=script&lang=js"
import style0 from "./GameRuleSearchBarComponent.vue?vue&type=style&index=0&id=e0b4a2c4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e0b4a2c4",
  null
  
)

export default component.exports